import React from 'react';
import { langCheck, getMenuitemsTree, handleExternalLinkUrl } from "Pub/js/utils";
import Ajax from "Pub/js/ajax";
import platform from "Pub/js/platform";
import { connect } from "react-redux";
import { SketchPicker } from 'react-color';
import ImgChooser from 'Components/ImgChooser';
import ImitateRefer from 'Components/ImitateRefer';
import { getMultiLangValue, getLanguageMetas } from 'Pub/js/getMulti';
import { getSpecialColorList } from '../../../NewHome/utilService';
const { base, DragWithCom, createPage, toast } = platform;
const { NCModal, NCButton, NCMultiLangText, NCRadio, NCTextArea, NCFormControl, NCSelect, NCPopconfirm, NCHotKeys, NCTooltip } = base;
const { NCRadioGroup } = NCRadio;
const { NCOption } = NCSelect;
import "./index.less";
import icon1 from "Assets/images/quickLaunch/icon1.svg";
import icon2 from "Assets/images/quickLaunch/icon2.svg";
import icon3 from "Assets/images/quickLaunch/icon3.svg";
import icon4 from "Assets/images/quickLaunch/icon4.svg";
import icon5 from "Assets/images/quickLaunch/icon5.svg";
import SelectIcon from 'Assets/images/select-icon.svg';
const getBase64Image = function (img) {
    return new Promise(resolve => {
        var image = new Image();
        image.src = img;
        image.onload = function () {
            var canvas = document.createElement("canvas");
            canvas.width = image.width;
            canvas.height = image.height;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(image, 0, 0, image.width, image.height);
            var ext = image.src.substring(image.src.lastIndexOf(".") + 1).toLowerCase();
            var dataURL = canvas.toDataURL("image/" + ext);
            resolve(dataURL);
        };
    });
};
let IconList = [];
getIconList(); // 加载base64的icon
async function getIconList() {
    IconList = [
        { src: await getBase64Image(icon1) },
        { src: await getBase64Image(icon2) },
        { src: await getBase64Image(icon3) },
        { src: await getBase64Image(icon4) },
        { src: await getBase64Image(icon5) },
        { key: 'custom' },
    ];
}
const BgList = getSpecialColorList();
const BgListBlack = getSpecialColorList('black');
const AppTreeId = 'appTree';
const pathMap = {
    2: 'widget_target_path',
    3: 'link_target_path',
};

@createPage()
class QuickLaunchModal extends React.Component {
    constructor(props) {
        super(props);
        const { currentData, themeType } = props;
        if (currentData) {
            const { quicklaunchtype, target_path } = currentData;
            currentData[pathMap[quicklaunchtype]] = target_path;
        }
        this.languageMetas = getLanguageMetas();
        const bgList = themeType === 'black' ? [...BgListBlack] : [...BgList];
        this.state = {
            bgList,
            cardList: [],
            selectCard: currentData ? { ...currentData } : this.getDefaultCard(bgList),
            appModalShow: false,
            widgetList: [], // 可选部件下拉数据列表
            verifyFailed: false, // 必填校验失败标识
        };
    }

    componentDidMount() {
        // console.log('quicklaunchmodal-didmount');
        this.getWidgets();
    }

    getDefaultCard(bgList) { // 表单信息(默认值)
        if (!bgList) {
            bgList = this.state.bgList;
        }
        return {
            quicklaunchtype: '1',
            displaytype: '2',
            icon: IconList[0].src,
            bgcolor: bgList[0].color,
            openparam: '',
        };
    }

    // 获取部件数据
    getWidgets() {
        const { relateidObj } = this.props;
        const { code: isuser } = relateidObj;
        Ajax({
            url: `/nccloud/platform/appregister/queryquicklaunchparts.do`,
            loading: true,
            data: { isuser },
            success: ({ data }) => {
                if (data.success) {
                    const dataList = data.data;
                    this.setState({ widgetList: dataList });
                }
            },
        });
    }

    // 新增卡片
    handleAdd() {
        const { cardList } = this.state;
        cardList.unshift({ title: '发起卡片' });
        this.setState({ cardList });
    }

    // 选中事件
    handleSelect(value, key) {
        const { selectCard } = this.state;
        selectCard[key] = value;
        this.setState({ selectCard });
    }

    modalClose(tip = false, close = true) {
        this.setState({ verifyFailed: false });
        // if (tip) {
        //     toast({
        //         content: langCheck('0000PUB-000514' /* 保存成功 */),
        //         color: 'success',
        //     });
        // }
        close && this.props.onCancel();
    }

    // 校验必填
    checkRequired() {
        const { selectCard } = this.state;
        const requiredLabels = [];
        if (!Object.keys(this.getTitleValue()).length) {
            console.log('没有填写标题');
            requiredLabels.push(langCheck('0000PUB-000445' /* 标题 */));
        }
        if (selectCard.quicklaunchtype == '1' && !selectCard.pagecode) {
            console.log('没有选择应用');
            requiredLabels.push(langCheck('0000PUB-000524' /* 跳转页面 */));
        }
        if (selectCard.quicklaunchtype == '2' && !selectCard.widget_target_path) {
            console.log('没有选择部件');
            requiredLabels.push(langCheck('0000PUB-000531' /* 选择部件 */));
        }
        if (selectCard.quicklaunchtype == '3' && !selectCard.link_target_path) {
            console.log('没有填写外部链接');
            requiredLabels.push(langCheck('0000PUB-000465' /* 网址 */));
        }

        if (requiredLabels.length) {
            toast({
                title: langCheck('0000PUB-000506' /* 提示 */),
                content: `${langCheck('0000PUB-000613' /* 以下字段不能为空 */)}：${requiredLabels.join(', ')}`,
                color: 'danger',
            });
            return false;
        }

        return true;
    }

    modalConfirm(continuous = false) {
        let { selectCard } = this.state;
        const { currentData, userId } = this.props;
        const requiredPass = this.checkRequired();
        if (!requiredPass) {
            this.setState({ verifyFailed: true });
            return;
        }

        const { defaultData = [] } = this.props;
        for (let i = 0; i < defaultData.length; i++) {
            if (defaultData[i] !== currentData) {
                for (let k in selectCard) {
                    if (k.startsWith('title') && selectCard[k] && defaultData[i][k] && selectCard[k] === defaultData[i][k]) {
                        toast({
                            content: langCheck('0000PUB-000567' /* 标题重复 */),
                            color: 'danger',
                        });
                        return;
                    }
                }
            }
        }

        const { quicklaunchtype } = selectCard;
        let target_path = selectCard[pathMap[quicklaunchtype]];
        if (quicklaunchtype === '3') {
            target_path = handleExternalLinkUrl(target_path);
        }
        selectCard = {
            ...selectCard,
            target_path,
        };

        if (currentData) { // 编辑时直接修改引用数据，这里直接关掉弹窗即可
            selectCard.modifier = userId;
            Object.assign(currentData, selectCard);
            this.props.onOk(defaultData);
            this.modalClose(true);
            return;
        }

        // console.log('modalConfirm', selectCard);
        this.props.onOk([...defaultData, {
            ...selectCard,
            creator: userId,

            // 下面这些字段在保存的时候统一赋值
            // position
            // workbenchid
            // relationid
            // pk_group_app
            // pk_group
        }]);

        if (continuous) { // 连续新增，不关闭弹窗
            this.setState({ selectCard: this.getDefaultCard() });
            this.modalClose(true, false);
            return;
        }

        this.modalClose(true);
    }

    // 选择应用跳转页面弹窗
    renderAppModal() {
        const { appModalShow } = this.state;
        const { syncTree } = this.props;
        const hotBtnStyle = { textDecoration: 'underline' };
        return <NCModal show={appModalShow} onHide={this.appModalClose.bind(this)}>
            <NCModal.Header closeButton>
                <NCModal.Title>{langCheck('0000PUB-000516' /* 选择应用节点 */)}</NCModal.Title>
            </NCModal.Header>

            <NCModal.Body>
                {
                    syncTree.createSyncTree({
                        treeId: AppTreeId, // 树组件唯一id
                        needSearch: true,
                        searchType: 'filtration',
                        needEdit: false, //是否需要编辑节点功能，默认为true,可编辑；false：不可编辑
                        lazyLoad: true,
                    })
                }
            </NCModal.Body>

            <NCModal.Footer>
                <NCHotKeys
                    keyMap={{ sureBtnHandler: NCHotKeys.USUAL_KEYS.MODAL_CONFIRM }}
                    handlers={{
                        sureBtnHandler: () => {
                            this.appModalConfirm();
                        },
                    }}
                    focused={true}
                />
                <NCButton colors="primary" onClick={this.appModalConfirm.bind(this)}>
                    {langCheck('0000PUB-000001' /* 确定 */)}(<span style={hotBtnStyle}>Y</span>)
                </NCButton>
                <NCButton colors="secondary" onClick={this.appModalClose.bind(this)}>
                    {langCheck('0000PUB-000000' /* 取消 */)}(<span style={hotBtnStyle}>N</span>)
                </NCButton>
            </NCModal.Footer>
        </NCModal>;
    }

    // 打开选择应用跳转页面弹窗
    openAppModal() {
        const { relateidObj } = this.props;
        const { code: isuser } = relateidObj;
        getMenuitemsTree({ containSmallComponent: false, isuser }).then(treeData => {
            const { syncTree } = this.props;
            syncTree.setSyncTreeData(AppTreeId, treeData);
            this.setState({ appModalShow: true });
        });
    }

    appModalConfirm() {
        const { syncTree } = this.props;
        const treeSelected = syncTree.getSelectNode(AppTreeId);
        if (!treeSelected || !treeSelected.isleaf) { return; }

        // console.log('appTreeSelected', treeSelected);
        const selectedParent = syncTree.getSyncTreeValue(AppTreeId, treeSelected.pid);
        const { selectCard } = this.state;
        selectCard.appid = treeSelected.appId;
        selectCard.menuitemid = selectedParent.pk;
        selectCard.menuitemcode = selectedParent.code;
        selectCard.appcode = treeSelected.appCode;
        selectCard.pagecode = treeSelected.code;
        selectCard.pagename = treeSelected.name; // 展示用
        selectCard.openparam = treeSelected.openpageparams || ''; // 跳转参数
        this.setState({ selectCard });
        this.appModalClose();
    }

    appModalClose() {
        const { syncTree } = this.props;
        syncTree.closeNodeByPk(AppTreeId);
        this.setState({ appModalShow: false });
    }

    // 获取标题多语值
    getTitleValue() {
        const { selectCard } = this.state;
        return getMultiLangValue('title', selectCard);
    }

    render() {
        // const { cardList } = this.state;
        // const leftDom = <div className='left-container'>
        //     <div className='left-container-title'>
        //         <span>快速发起（0）</span>
        //         <span className='opr-add' onClick={ this.handleAdd.bind(this) }><i className='iconfont icon-ncc-sq'></i>新增</span>
        //     </div>
        //     <div className='left-container-main'>
        //         {
        //             cardList.map(item => <div className='card-item'>
        //                 <img></img>
        //                 <span>{ item.title }</span>
        //             </div>)
        //         }
        //     </div>
        // </div>

        const { selectCard, widgetList, verifyFailed, bgList } = this.state;
        const { relateidObj, currentData, themeType } = this.props;
        const colorPicker = <SketchPicker
            color={selectCard.bgcolor}
            onChange={color => {
                this.handleSelect(color.hex, 'bgcolor');
            }}
        />;
        const isCustomColor = bgList.every(item => item.color !== selectCard.bgcolor); // 没有找到，说明是自定义的
        const isCustomIcon = IconList.every(item => item.src !== selectCard.icon); // 没有找到，说明是自定义的
        const widgetSelected = widgetList.find(item => item.target_path === selectCard.widget_target_path);
        const rightDom = <div className='right-container'>
            <div className='info'>
                <span className='info-title'>{langCheck('0000PUB-000517' /* 基础信息 */)}</span>
                <div className='info-item'>
                    <div className='info-label'>
                        <span className='item-label required'>{langCheck('0000PUB-000445' /* 标题 */)}</span>
                    </div>
                    <div className={`info-content ${verifyFailed && !Object.keys(this.getTitleValue()).length ? 'error' : ''} title`}>
                        <NCMultiLangText maxlength={200} fieldid='quick-launch-title' placeholder={langCheck('0000PUB-000518' /* 建议字数不超过9个字 */)} value={this.getTitleValue()} attrcode='title' languageMeta={this.languageMetas} onChange={val => {
                            for (let k in val) {
                                selectCard[k] = val[k].value;
                            }
                            this.setState({ selectCard });
                        }}></NCMultiLangText>
                    </div>
                </div>
                <div className='info-item'>
                    <div className='info-label'>
                        <span className='item-label'>{langCheck('0000PUB-000446' /* 图标 */)}</span>
                    </div>
                    <div className='info-content'>
                        {
                            IconList.map((item, index) => <div className={`item-select icon-${index} ${(isCustomIcon ? item.key === 'custom' : item.src === selectCard.icon) ? 'active' : ''}`}>
                                <img className='select-icon' src={SelectIcon} />
                                <div
                                    style={{ backgroundImage: `url(${(item.key === 'custom' && isCustomIcon) ? selectCard.icon : item.src})` }}
                                    className={`icon-item`}
                                    onClick={() => {
                                        if (item.key === 'custom') { return; } // 自定义的等图片选择完毕后赋值
                                        this.handleSelect(item.src, 'icon');
                                    }
                                    }
                                >
                                    {
                                        item.key === 'custom' && <ImgChooser
                                            className='icon-custom'
                                            onChange={value => {
                                                this.handleSelect(value, 'icon');
                                            }}
                                        >
                                            <i className='iconfont icon-ncc-sq custom-add'></i>
                                        </ImgChooser>
                                    }
                                </div>
                            </div>)
                        }
                    </div>
                </div>
                <div className='info-item'>
                    <div className='info-label'>
                        <span className='item-label'>{langCheck('0000PUB-000519' /* 背景色 */)}</span>
                    </div>
                    <div className='info-content'>
                        {
                            bgList.map((item, index) => <div className={`item-select bg-${index} ${(isCustomColor ? item.key === 'custom' : item.color === selectCard.bgcolor) ? 'active' : ''}`}>
                                <img className='select-icon' src={SelectIcon} />
                                <div
                                    className={`bg-item`}
                                    style={{
                                        background: item.key === 'custom' ? 'linear-gradient(134deg, rgb(204, 103, 103) 0%, rgb(63, 85, 242) 21%, rgb(75, 206, 57) 43%, rgb(255, 227, 100) 70%, rgb(236, 68, 68) 100%)' : item.color,
                                        borderColor: item.borderColor,
                                    }}
                                    onClick={() => {
                                        if (item.key === 'custom') { return; } // 自定义的通过颜色选择器触发数据变化
                                        this.handleSelect(item.color, 'bgcolor');
                                    }}
                                >
                                    {
                                        item.key === 'custom' && <NCPopconfirm
                                            className="quick-launch-color-picker"
                                            onClick={() => { this.handleSelect(selectCard.bgcolor, 'bgcolor'); }}
                                            trigger="click"
                                            placement="right"
                                            content={colorPicker}
                                        >
                                            <div style={{ height: '100%' }}></div>
                                        </NCPopconfirm>
                                    }
                                </div>
                            </div>)
                        }
                    </div>
                </div>
            </div>
            {
                <div className='info'>
                    <span className='info-title'>{langCheck('0000PUB-000520' /* 数据信息 */)}</span>
                    <div className='info-item' style={{ lineHeight: '18px' }}>
                        <div className='info-label'>
                            <span className='item-label'>{langCheck('0000PUB-000521' /* 类型 */)}</span>
                        </div>
                        <div className='info-content'>
                            <NCRadioGroup
                                name='typeRadioGroup'
                                selectedValue={selectCard.quicklaunchtype}
                                onChange={val => {
                                    this.handleSelect(val, 'quicklaunchtype');
                                }}
                            >
                                <NCRadio fieldid='quick-launch-type-1' value='1'>{langCheck('0000PUB-000384' /* 应用 */)}</NCRadio>
                                <NCRadio fieldid='quick-launch-type-2' value='2'>{langCheck('0000PUB-000522' /* 部件 */)}</NCRadio>
                                <NCRadio fieldid='quick-launch-type-3' value='3'>{langCheck('0000PUB-000523' /* 外部链接 */)}</NCRadio>
                            </NCRadioGroup>
                        </div>
                    </div>
                    {
                        selectCard.quicklaunchtype === '1' && <React.Fragment>
                            <div className='info-item'>
                                <div className='info-label'>
                                    <span className='item-label required'>{langCheck('0000PUB-000524' /* 跳转页面 */)}</span>
                                </div>
                                <ImitateRefer fieldid="quick-launch-jump-page" className={`info-content ${verifyFailed && !selectCard.pagename ? 'error' : ''} jump-page`} placeholder={langCheck('0000PUB-000528' /* 请选择应用节点 */)} value={selectCard.pagename} onClick={this.openAppModal.bind(this)} />
                            </div>
                            <div className='info-item'>
                                <div className='info-label'>
                                    <span className='item-label'>{langCheck('0000PUB-000525' /* 跳转参数 */)}</span>
                                </div>
                                <div className='info-content jump-params'>
                                    <NCTextArea isCheckChinese maxlength={200} value={selectCard.openparam} onChange={val => {
                                        // 直接改值，减少setState导致的render
                                        selectCard.openparam = val;
                                    }} />
                                    <div className='params-example'>{langCheck('0000PUB-000526' /* 例如 */)}：status=add</div>
                                </div>
                            </div>
                            <div className='info-item'>
                                <div className='info-label'>
                                    <span className='item-label'>{langCheck('0000PUB-000527' /* 展示方式 */)}</span>
                                </div>
                                <div className='info-content'>
                                    <NCRadioGroup
                                        name='displayRadioGroup'
                                        selectedValue={selectCard.displaytype}
                                        onChange={val => {
                                            this.handleSelect(val, 'displaytype');
                                        }}
                                    >
                                        <NCRadio value='2'>{langCheck('0000PUB-000529' /* 页面 */)}</NCRadio>
                                        <NCRadio value='1'>{langCheck('0000PUB-000530' /* 弹窗 */)}</NCRadio>
                                    </NCRadioGroup>
                                </div>
                            </div>
                            {
                                selectCard.displaytype === '1' && <div className='info-item'>
                                    <div className='info-label'>
                                        <span className='item-label'>{langCheck('0000PUB-000602' /* 弹窗尺寸 */)}</span>
                                    </div>
                                    <div className='info-content'>
                                        <NCSelect
                                            value={selectCard.windowsize || 'max'}
                                            showClear={false}
                                            onSelect={val => {
                                                this.handleSelect(val, 'windowsize');
                                            }}
                                        >
                                            <NCOption value='sm'>sm</NCOption>
                                            <NCOption value='md'>md</NCOption>
                                            <NCOption value='lg'>lg</NCOption>
                                            <NCOption value='xlg'>xlg</NCOption>
                                            <NCOption value='max'>max</NCOption>
                                            <NCOption value='custom'>{langCheck('0000PUB-000490' /* 自定义 */)}</NCOption>
                                        </NCSelect>
                                    </div>
                                </div>
                            }
                        </React.Fragment>
                    }
                    {
                        selectCard.quicklaunchtype === '2' && <div className='info-item'>
                            <div className='info-label'>
                                <span className='item-label required'>{langCheck('0000PUB-000531' /* 选择部件 */)}</span>
                            </div>
                            <div className={`info-content ${verifyFailed && !selectCard.widget_target_path ? 'error' : ''} widget`}>
                                <NCSelect
                                    virtual={false}
                                    value={widgetSelected}
                                    placeholder={langCheck('0000PUB-000532' /* 请选择快速发起部件 */)}
                                    onSelect={val => {
                                        selectCard.widget_target_path = val;
                                        const selectWidget = widgetList.find(item => item.target_path === val);
                                        if (selectWidget) {
                                            selectCard.appcode = selectWidget.appcode;
                                            selectCard.menuitemid = selectWidget.value;
                                            selectCard.menuitemcode = selectWidget.code;
                                            selectCard.appid = selectWidget.appid;
                                        }
                                        this.setState({ selectCard });
                                    }}
                                >
                                    {
                                        widgetList.map(item => <NCOption value={item.target_path}>{item.label}</NCOption>)
                                    }
                                </NCSelect>
                            </div>
                        </div>
                    }
                    {
                        selectCard.quicklaunchtype === '3' && <div className='info-item'>
                            <div className='info-label'>
                                <span className='item-label required'>{langCheck('0000PUB-000465' /* 网址 */)}</span>
                            </div>
                            <div className={`info-content ${verifyFailed && !selectCard.link_target_path ? 'error' : ''} url`}>
                                <NCFormControl isCheckChinese maxlength={500} fieldid='quick-launch-link-path' placeholder={langCheck('0000PUB-000533' /* 请填写链接访问地址 */)} value={selectCard.link_target_path} onChange={val => {
                                    this.handleSelect(val, 'link_target_path');
                                }} />
                            </div>
                        </div>
                    }
                </div>
            }
        </div>;
        return <NCModal fieldid="quick-launch" zIndex={300} className="quick-launch-modal" show={true} onHide={() => { this.modalClose(); }}>
            <NCModal.Header closeButton>
                <NCModal.Title>{currentData ? langCheck('0000PUB-000534' /* 卡片设置 */) : langCheck('0000PUB-000535' /* 新增卡片 */)}</NCModal.Title>
            </NCModal.Header>

            <NCModal.Body>
                {/* <DragWithCom
                    leftDom={leftDom} // 左侧区域dom
                    rightDom={rightDom} // 右侧区域dom
                    defLeftWid='30%' // 默认左侧区域宽度，px/百分百
                /> */}
                {rightDom}
            </NCModal.Body>

            <NCModal.Footer>
                <NCHotKeys
                    keyMap={{
                        saveHandler: NCHotKeys.USUAL_KEYS.SAVE,
                        saveAddHandler: NCHotKeys.USUAL_KEYS.SAVE_ADD,
                        cancelHandler: NCHotKeys.USUAL_KEYS.MODAL_CANCEL,
                    }}
                    handlers={{
                        saveHandler: () => { this.modalConfirm(); },
                        saveAddHandler: () => { this.modalConfirm(true); },
                        cancelHandler: () => { this.modalClose(); },
                    }}
                    focused={true}
                />
                <NCTooltip
                    overlay={`${langCheck('0000PUB-000007' /* 保存 */)}(${NCHotKeys.USUAL_KEYS.SAVE})`}
                >
                    <NCButton colors="primary" onClick={() => { this.modalConfirm(); }}>
                        {langCheck('0000PUB-000007' /* 保存 */)}(<span className="underline">S</span>)
                    </NCButton>
                </NCTooltip>
                {!currentData && <NCTooltip
                    overlay={`${langCheck('0000PUB-000503' /* 保存新增 */)}(${NCHotKeys.USUAL_KEYS.SAVE_ADD})`}
                >
                    <NCButton colors="secondary" onClick={() => { this.modalConfirm(true); }}>
                        {langCheck('0000PUB-000503' /* 保存新增 */)}(<span className="underline">S</span>)
                    </NCButton>
                </NCTooltip>}
                <NCTooltip
                    overlay={`${langCheck('0000PUB-000000' /* 取消 */)}(${NCHotKeys.USUAL_KEYS.MODAL_CANCEL})`}
                >
                    <NCButton colors="secondary" onClick={() => { this.modalClose(); }}>
                        {langCheck('0000PUB-000000' /* 取消 */)}(<span className="underline">N</span>)
                    </NCButton>
                </NCTooltip>
            </NCModal.Footer>

            {this.renderAppModal()}
        </NCModal>;
    }
}

export default connect(
    state => ({
        benchData: state.appData.workbenchData,
        userId: state.appData.userId,
        themeType: state.appData.themeColor,
    }),
    {},
)(QuickLaunchModal);